import React, { useEffect, useState } from "react";
import SplitPane from "react-split-pane";
import STDMMethodTableProperties from "./STDMMethodTableProperties";
import STDMMethodTableData from "./STDMMethodTableData";
import UseToggle from "../../../../../Hooks/UseToggle";
import UpdateMethod from "./UpdateMethod";
import { Collapse, Form, InputGroup, Spinner } from "react-bootstrap";
import { GoSearch } from "react-icons/go";
import { cdiscServices } from "../../../../../Services/CDISC/cdiscServices";
import { useParams } from "react-router";

const STDMMethod = ({ onMouseDown, tableRef }) => {
  const [loader, setLoader] = useState(false);
  const { toggle, setToggle } = UseToggle();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [stdmMethod, setSTDMMethod] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState("");
  const { studyId } = useParams();

  const getCDISCMathods = async () => {
    setLoader(true);
    let data = await cdiscServices.getCDISCMathods(studyId);
    setSTDMMethod(data?.data || []);
    setLoader(false);
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  useEffect(() => {
    getCDISCMathods();
  }, []);

  return (
    <div className={`code-list-container ${isFullScreen ? "full-screen" : ""}`}>
      <div className="p-1 hstack justify-content-between border-bottom toolbar">
        <div className="hstack gap-2">
          {isFormOpen && (
            <>
              <i
                title="Close Form"
                className="fa-solid fa-square-caret-left CP"
                onClick={() => setIsFormOpen("")}
              />
              <div className="vr"></div>
            </>
          )}
          <i
            title="Table Properties"
            className="fa-solid fa-list CP"
            onClick={setToggle}
          />
          <div className="vr"></div>
          <i
            className="fa-solid fa-magnifying-glass"
            title="Search"
            onClick={() => setOpenFilter(!openFilter)}
          ></i>
          <Collapse in={openFilter} dimension="width">
            <div>
              <InputGroup style={{ width: 200 }}>
                <Form.Control
                  type="search"
                  className="px-2"
                  placeholder="Search..."
                  style={{ fontSize: 10, borderRadius: "0", padding: 0 }}
                />
                <InputGroup.Text
                  id="basic-addon2"
                  style={{ padding: "1px 5px" }}
                >
                  <GoSearch />
                </InputGroup.Text>
              </InputGroup>
            </div>
          </Collapse>
        </div>
        {isFullScreen ? (
          <i
            className="fa-solid fa-maximize"
            title="Original Mode"
            onClick={toggleFullScreen}
          ></i>
        ) : (
          <i
            className="fa-solid fa-minimize"
            title="Full Mode"
            onClick={toggleFullScreen}
          ></i>
        )}
      </div>
      <div className="position-relative">
        <SplitPane
          split="horizontal"
          style={{
            height: isFullScreen ? "calc(100vh - 35px)" : "calc(100vh - 148px)",
          }}
          defaultSize={"100%"}
        >
          <SplitPane
            split="vertical"
            minSize={20}
            defaultSize={isFormOpen ? "20%" : "100%"}
          >
            {isFormOpen && (
              <UpdateMethod
                isFormOpen={isFormOpen}
                studyId={studyId}
                getCDISCMathods={getCDISCMathods}
              />
            )}
            <>
              {loader ? (
                <div className="hstack justify-content-center h-100 w-100">
                  <Spinner />
                </div>
              ) : stdmMethod?.length === 0 ? (
                <div className="hstack justify-content-center h-100 w-100">
                  Data not found!
                </div>
              ) : (
                <STDMMethodTableData
                  studyId={studyId}
                  stdmMethod={stdmMethod}
                  onMouseDown={onMouseDown}
                  tableRef={tableRef}
                  setIsFormOpen={setIsFormOpen}
                  getCDISCMathods={getCDISCMathods}
                />
              )}
            </>
          </SplitPane>
        </SplitPane>
      </div>
      <STDMMethodTableProperties
        Show={!toggle}
        Hide={setToggle}
        Title={"Table Properties"}
      />
    </div>
  );
};

export default STDMMethod;
